import { Controller } from '@hotwired/stimulus'
import * as analytics from '../utils/analytics'
import { internalLog } from '../utils/logger'

export default class extends Controller {
  connect () {
    this.id = null
    const { uiVersion } = this.element.dataset
    const analyticsData = this.element.dataset.analytics
    let analyticsObject
    if (analyticsData) {
      try {
        analyticsObject = JSON.parse(analyticsData).object
      } catch (e) {
        internalLog(e)
      }
    } else {
      analyticsObject = this.element.dataset.analyticsObject
    }

    const intervals = [
      [0, '0-1'],
      [1, '1-5'],
      [5, '6-10'],
      [5, '11-20'],
      [10, '21-30'],
      [10, '31-60'],
      [30, '61-90'],
      [30, '91-120'],
      [30, '121-180'],
      [60, '181+']
    ]

    const trackTime = () => {
      const next = intervals.shift()
      if (!next) return

      const [timeout, secs] = next

      this.id = setTimeout(() => {
        // TODO: Ensure eventLabel is set here so it doesnt get picked up from previous event
        const eventName = `${analyticsObject}_timeonpage`
        analytics.track(eventName, {
          eventAction: `${secs} seconds`
        }, { adapter: 'gtm' })

        analytics.track(eventName, {
          object: analyticsObject,
          action: 'timeonpage',
          time_period: secs,
          ...(uiVersion && { ui_version: uiVersion })
          // TODO: Add more context properties
        }, { adapter: 'segment' })

        trackTime()
      }, timeout * 1000)
    }

    trackTime()
  }

  disconnect () {
    clearTimeout(this.id)
  }
}
